import Vue from 'vue';
import '@oasis/system'; // Addon-System
import './set-public-path';
import '@/assets/scss/main.scss';
import singleSpaVue from 'single-spa-vue';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store';

moment.locale('es');

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render: (h) => h(App),
    i18n: global.i18n,
    router,
    store,
  },
});

export const { bootstrap } = vueLifecycles;
export const { mount } = vueLifecycles;
export const { unmount } = vueLifecycles;
